// src/admin/AddDeviceModal.tsx

import { Modal, Button, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
// import authApi from "services/authApi";
import http from "services/httpClient";

// Import the user type if you have it
interface Client {
  id: number;
  name: string;
}

interface AddDeviceModalProps {
  show: boolean;
  onHide: () => void;
  onSave: (deviceData: {
    device_name: string;
    client_id: number;
    conn: number;
    param_count: number;
  }) => void;
}

export const AddDeviceModal = ({ show, onHide, onSave }: AddDeviceModalProps) => {
  const [device_name, setDeviceName] = useState("");
  // const [userId, setUserId] = useState<number>(0);
  const [conn, setConn] = useState<number>(1); // 1=FTP, 2=MQTT
  const [clients, setClients] = useState<Client[]>([]);
  const [client_id, setClientId] = useState<number>(0);
  const [param_count, setParamCount] = useState<number>(0);

  useEffect(() => {
    const fetchClients = async () => {
      const res = await http.get(`/clients`);
      const data = await res.data;
      setClients(data);
    };

    if (show) {
      fetchClients();
    }
  }, [show]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({
      device_name,
      client_id,
      conn,
      param_count
    });
    setDeviceName("");
    setClientId(0);
    setConn(1);
    setParamCount(0);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Add Device</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="deviceName">
            <Form.Label>Device Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter device name"
              value={device_name}
              onChange={(e) => setDeviceName(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="client">
            <Form.Label>Client</Form.Label>
            <Form.Select
              value={client_id}
              onChange={(e) => setClientId(Number(e.target.value))}
              required
            >
              <option value="">Select client</option>
              {clients.map((client) => (
                <option key={client.id} value={client.id}>
                  {client.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3" controlId="conn">
            <Form.Label>Conn</Form.Label>
            <Form.Select
              value={conn}
              onChange={(e) => setConn(Number(e.target.value))}
              required
            >
              <option value={1}>FTP</option>
              <option value={2}>MQTT</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3" controlId="param_count">
            <Form.Label>Parameter Count</Form.Label>
            <Form.Select
              value={param_count}
              onChange={(e) => setParamCount(Number(e.target.value))}
              required
            >
              {Array.from({ length: 30 }, (_, i) => i + 1).map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </Form.Select>
          </Form.Group>


          <div className="d-flex justify-content-end">
            <Button variant="danger" onClick={onHide} className="me-2">
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Save
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddDeviceModal;
